export default "__VITE_ASSET__DKGxPpRO__"